import React, { useEffect } from 'react';
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessNotification = ({ open, onCloseNotification }) => {

    // a useEffect to close the notification after 3 seconds or when the user clicks the close button
    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                onCloseNotification();
            }, 8000);

            return () => clearTimeout(timer);
        }
    }, [open, onCloseNotification]);

    return (
        <Snackbar
            open={open}
            autoHideDuration={8000}
            onClose={onCloseNotification}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
            <Alert
                onClose={onCloseNotification}
                severity='success'
                icon={<CheckCircleIcon />}
                sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    backdropFilter: "blur(20px) saturate(180%)",
                    WebkitBackdropFilter: 'blur(20px) saturate(180%)',
                    border: '1px solid #09ba41',
                    borderRadius: '12px',
                    fontWeight: '500',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    color: '#09ba41',
                    '& .MuiAlert-icon': {
                        color: "#09ba41",
                    },
                    '& .MuiAlert-message': {
                        color: '#09ba41',
                        fontSize: '14px',
                        fontWeight: '500',
                    },
                    '& .MuiAlert-action': {
                        color: '#09ba41',
                        '&:hover': {
                            color: '#09ba41',
                        }
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        border: '1px solid rgba(255, 255, 255, 0.4)',
                    }

                }}
            >
                Your message has been received by Fiducia | AI.
            </Alert>
        </Snackbar>
    );
};

export default SuccessNotification;